import { useAtom } from "jotai";
import { libMisc } from "../../../../lib/misc";
import { s } from "../../../../lib/styler";
import { ConversationHeader } from "../../../../types";
import Icon from "../../../commons/Icon";
import TextEllipsis from "../../../commons/TextEllipsis";
import { LOADING_DIRECTIVE, serviceSync } from "../../../../services/sync.service";
import { useEffect, useState } from "react";

export type MessagingConversationHeaderProps = {
    header: ConversationHeader;
    selected?: boolean;
    onClick?: () => void;
}

export default function MessagingConversationHeader({ header: { id, name, lastMessage, timestamp }, selected = false, onClick }: MessagingConversationHeaderProps) {
    const [selectedConversation] = useAtom(serviceSync.atomSelectedConversation);

    let showDraft = false;
    let draftText = serviceSync.getDraft(id).text.trim();
    let draftMediaBlobIds = serviceSync.getDraft(id).mediaBlobIds;
    if (id !== selectedConversation && (draftText !== "" || draftMediaBlobIds.length > 0)) {
        lastMessage = draftText || ((draftMediaBlobIds.length > 1) ? "(images)" : "(image)");
        showDraft = true;
    }
    else {
        lastMessage = lastMessage || "(image)";
    }

    let additionalClasses = "";
    if (lastMessage === LOADING_DIRECTIVE) {
        lastMessage = "Thinking...";
        additionalClasses = "italic";
    }

    return (
        <div className={s(`bg-[#ededed] active:bg-blue-300 flex px-6 py-[20px] border-b cursor-pointer border-gray-300`, {}, [
            ["md:bg-white md:active:bg-white", "md:active:bg-[#f6f6f6] md:hover:bg-[#f6f6f6] transition-colors duration-200", selected]
        ])} onClick={onClick}>
            <div className="pr-[8px] pt-[2px] w-[28px]">
                <Icon name="bxs-envelope" color="#f7e176" size="20px" />
            </div>
            <div className="flex-grow flex flex-col gap-[3px]">
                <TextEllipsis className="text-[14px] font-bold text-gray-700" height={21}>{name.trim() || "(unknown)"}</TextEllipsis>
                <TextEllipsis className={`text-[12px] text-gray-600 ${additionalClasses}`} height={18}>{showDraft && <span className="text-red-800">Draft: </span>}{lastMessage}</TextEllipsis>
            </div>
            <div className="text-[10px] text-gray-600 pt-[3px] pl-[6px]">
                {libMisc.formatTimestamp(timestamp)}
            </div>
        </div>
    );
}